import { useEffect } from "react";
import courseService from "../../services/courseService";
import { useState } from "react";
import Course from "./Course";
import { Button } from "../ui/button";
import { Link } from "react-router-dom";
export default function Courses () {
  const [courses,setCourses] = useState([])
  const fetchCourse = async () => {
    try {
      const res = await courseService.getAllCourses()
      setCourses(res.data)

    } catch (error) {

    }
  }
  useEffect(() => {
    fetchCourse()
  }, [])

  return (
    <div className="py-8 space-y-4">
      <h1 className="font-[Phudu] font-bold text-center text-2xl">KHÓA HỌC NỔI BẬT</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {
        courses.filter(course => course.id < 5).map(course => (
          <Course key={course.id} course={course}/>
        ))
      }
      </div>
      <div className="text-center">
      <Link to={"/courses"}>
      <Button className="rounded-full">

         Xem thêm


      </Button>
      </Link>
      </div>


    </div>
  )
}
